import type { CSSProperties } from "react";

export const DEFAULT_STUDIO_IMAGE_WIDTH = 1600;
export const DEFAULT_STUDIO_IMAGE_HEIGHT = 900;

export type StudioImageSpacingRem = 0 | 0.5 | 1 | 1.5 | 2;

export type StudioImageStyleProps = {
  width: number;
  height: number;
  marginRem?: StudioImageSpacingRem;
  paddingRem?: StudioImageSpacingRem;
};

export function resolveStudioImageDimensions(width: number, height: number) {
  return {
    width: width > 0 ? width : DEFAULT_STUDIO_IMAGE_WIDTH,
    height: height > 0 ? height : DEFAULT_STUDIO_IMAGE_HEIGHT,
  };
}

export function normalizeStudioImageSpacingRem(
  value: unknown,
): StudioImageSpacingRem {
  if (value === 0.5 || value === 1 || value === 1.5 || value === 2) {
    return value;
  }
  return 0;
}

export function getStudioImageWrapperStyle(
  props: StudioImageStyleProps,
): CSSProperties {
  const dimensions = resolveStudioImageDimensions(props.width, props.height);
  const marginRem = normalizeStudioImageSpacingRem(props.marginRem);
  const paddingRem = normalizeStudioImageSpacingRem(props.paddingRem);

  return {
    width: dimensions.width,
    maxWidth: "100%",
    height: "auto",
    margin: marginRem === 0 ? 0 : `${marginRem}rem`,
    padding: paddingRem === 0 ? undefined : `${paddingRem}rem`,
  };
}

export function getStudioImageClassName(): string {
  return "shadow-md rounded-lg h-auto max-w-full";
}

/** Local object-URL used only while a Studio image is selected but not uploaded. */
export function isStudioPendingImageSrc(src: string): boolean {
  return src.startsWith("blob:");
}
